export default {
  q: { title: 'Поле поиск содержит', handler: 'plain' },
  type: { title: 'Тип объекта', handler: 'type' },
  organization: { title: 'Организация', handler: 'org' },
  author: { title: 'Поле автор содержит', handler: 'plain' },
  title: { title: 'Поле заголовок содержит', handler: 'plain' },
  annotation: { title: 'Поле аннотация содержит', handler: 'plain' },
  keyword: { title: 'Поле ключевое слово содержит', handler: 'plain' },
  country: { title: 'Страна', handler: 'vocabulary', voc: 'countries' },
  license: { title: 'Типовой смарт-контракт', handler: 'license' },
  udc: { title: 'Идентификатор УДК', handler: 'vocabulary', voc: 'UDC' },
  rcea: { title: 'Идентификатор ОКВЭД', handler: 'vocabulary', voc: 'RCEA' },
  dateStart: { title: 'Объект депонирован не ранее', handler: 'date' },
  dateEnd: { title: 'Объект депонирован не позднее', handler: 'date' },
  existPreview: { title: 'Есть файлы предпросмотра', handler: 'boolean' },
};



// WEBPACK FOOTER //
// ./src/data/search-filters.js